export default {
  // Appointment
  appointment: 'Appointment',
  appointments: 'Appointments',
  'appointment-details': 'Appointment details | {appointmentType}',
  'appointments.empty': 'You have not booked any appointments yet.',
  'appointments-requested.empty': 'You have not requested any appointments yet.',
  'appointments-past.empty': 'No past appointments available',

  'appointment.cancellation': 'Appointment cancellation',
  'appointment.cancellation.description': 'This appointment was canceled.',
  'appointment.cancellation.reasons': 'Reasons for cancellation: {reasons}',
  'appointment.cancellation.no-reasons': 'No cancellation reason given',

  'appointment.archiving': 'Appointment archiving',
  'appointment.archiving.description': 'This appointment has been archived.',

  'appointment-details.empty': 'Select an appointment from the list to view it',
  'appointment-cancel': 'Cancel appointment',
  'appointment-cancel.ishmed-tooltip':
    'This appointment can only be postponed or canceled by telephone. Please contact the clinic.',
  'appointment-edit': 'Edit',
  'appointment-type': 'Appointment type',
  'appointment.upload-document': 'Upload document',
  'appointment.patient-info': 'Patient information',
  'appointment.clinic-info': 'Clinic information',
  'appointments.load-more': 'Show more',

  cancelled: 'Cancelled',
  'appointment.cancelled': 'Cancelled: {reasons}',
  'appointment.cancelled.no-reason': 'No cancellation reason given',

  // Proposal
  'appointment.proposal': 'Appointment proposals',
  'appointment.proposal.accept.title': 'Accept proposal',
  'appointment.proposal.accept.description':
    'You have selected the proposed appointment on {date}. Do you want to confirm it?',
  'appointment.proposal.accept': 'Accept',
  'appointment.proposal.accept.success': 'The appointment was booked successfully',
  'notification.error': 'An unexpected error has occurred',
  'appointment.proposal.reject-all': 'I cannot attend any of these appointments',
  'appointment.proposal.description':
    'You have received a list of suggested appointments from the clinic. Please select your desired appointment to confirm it.',
  'appointment-proposal.reject.title': 'Reject appointment proposals',
  'appointment-proposal.reject': 'Reject',
  'appointment-proposal.reject.info': 'Proposed dates were rejected',
  'appointment-proposal.reject.description':
    'Are you sure you want to reject all appointment proposals?',

  'success.appointment-booked': 'Appointment successfully booked',

  'appointment-successful.appointment-overview': 'Appointment overview',
  'appointment-successful.add-google-calendar': 'Add to Google calendar',
  'appointment-successful.add-google-calendar.short': 'Add to Google calendar',
  'appointment-successful.add-ical-calendar.short': 'Add to calendar',
  'appointment.route': 'Show route',

  // Video appointment
  'video-appointment': 'Video appointment',
  'video-appointment.text':
    'You are about to book a video appointment. You will receive all further information after the appointment booking is completed.',
  'video-appointment.description':
    'Here you can start your video consultation. You will be redirected to another page. Your video call will start as soon as your doctor has started it.',
  'video-appointment.start': 'Start video appointment',

  // In person appointment
  'in-person-appointment': 'Appointment on site',

  // Tasks
  'appointment-tasks.title': 'Tasks',

  'appointment-tasks.before': 'Before appointment',
  'appointment-tasks.after': 'After appointment',
  'appointment-tasks.while': 'During appointment',

  'appointment-tasks.upload-document': 'Share document',
  'appointment-tasks.share': 'Upload selected documents',
  'appointment-tasks.upload-document.header': 'Click or drag the file to upload it to this area',
  'appointment-tasks.upload-document.description':
    'Selected files are transmitted encrypted and can be viewed at your appointment.',

  'appointment.add-event.summary': 'Appointment information',
  'appointment.add-event.link': 'Show in Google calendar',
  'appointment.add-event.success': 'Appointment was successfully added to the calendar',
  'appointment.add-event.fail': 'Appointment could not be added to your calendar',
  'appointment.add-event.ical': 'Add to calendar',

  'appointment.rebooking': 'Appointment rescheduling',
  'appointment.reasons-for-rebooking': 'Attention: This date has been rebooked!',
  'appointment.rebooking.latest-date': 'New date: {date}',

  'appointment.not-verified': 'Not verified',
  'appointment.not-verified.description':
    'This appointment will be deleted shortly if you do not confirm your account.',
  'appointment-request.not-verified': 'Not verified',
  'appointment-request.not-verified.description':
    'This request will be deleted shortly if you do not confirm your account.',

  'cancel-appointment.title': 'Appointment cancellation',
  'cancel-appointment.success': 'Your appointment on {date} was canceled',
  'cancel-appointment-request.success': 'Your approintment request was cancelled',
  'cancel-appointment.reason': 'Please tell us why you want to cancel your appointment',

  'appointment.booked-at': 'Appointment booked on {bookedAt}',
  'appointment-request.booked-at': 'Appointment request made on {bookedAt}',

  'appointment.route.short': 'Route',
  'appointment.calendar.short': 'Calendar',
  'appointment.google-calendar.short': 'Calendar',
  'appointment.qr-code.short': 'QR-code',
  'appointment.qr-code': 'Show QR-code',

  'upcoming-appointments': 'Upcoming appointments',

  'appointment.group-appointment': 'Group appointment',
  'appointment.group-appointment.description': 'The booked appointment is a group appointment.',
  'appointment.group-appointment.quota': '{count} / {quota} slots are booked.',

  'appointment.history': 'History',
  'appointment.history.sub-title': 'History',
  'appointment.history.more': 'Show more',

  'appointment.history.event.booked.booked': 'The appointment was booked.',
  'appointment.history.event.booked.update': 'This appointment was rescheduled.',
  'appointment.history.event.cancelled': 'This appointment was cancelled.',
  'appointment.history.event.counter-request-submitted': 'A counter-request has been sent.',
  'appointment.history.event.finished': 'The appointment is finished.',
  'appointment.history.event.missed': 'It seems you missed this appointment.',
  'appointment.history.event.ongoing': 'The appointment is in progress.',
  'appointment.history.event.proposals-rejected.booked': 'The appointment proposals were rejected.',
  'appointment.history.event.proposals-rejected.update':
    'The proposals for rescheduling were rejected.',
  'appointment.history.event.proposals-accepted': 'You have accepted this appointment.',
  'appointment.history.event.proposals-received': 'Proposal received.',
  'appointment.history.event.requested.book': 'Your booking has been requested.',
  'appointment.history.event.requested.update': 'Your appointment change has been requested.',
  'appointment.history.event.request-approved': 'The appointment request was confirmed.',
  'appointment.history.event.request-rejected': 'The appointment request was rejected.',
  'appointment.history.event.reserved': 'The appointment is reserved.',

  // Phone appointment
  'phone-appointment': 'Phone consultation',
  'phone-appointment.text':
    'You are about to book a phone consultation. You will receive all further information once the booking is completed.',
  'phone-appointment.external.default-text':
    'You will receive a separate email for the phone consultation.',

  // Video appointment extra
  'video-appointment.external.default-text':
    'You will receive a separate email for the video consultation.',
};
